import { GLOBALS } from 'constants/app/global-variables';

const processPath = (path: string, shouldRemoveLeadingSlash: boolean) => {
  if (!shouldRemoveLeadingSlash) {
    return path;
  }
  return path.replace(/^\//, '');
};

export const getInitialMountingPath = (shouldRemoveLeadingSlash = false) => {
  return processPath(
    GLOBALS.navigation.initialMountingPath,
    shouldRemoveLeadingSlash
  );
};
